import type { User } from 'firebase/auth';

function parseJwt(token: string): { exp: number; [key: string]: any } {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    Buffer.from(base64, 'base64')
      .toString('binary')
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join(''),
  );
  return JSON.parse(jsonPayload);
}

export function startTokenRefreshMonitoring(
  user: User,
  verbose: boolean,
): NodeJS.Timeout {
  return setInterval(async () => {
    try {
      const currentToken = await user.getIdToken(false);
      const decoded = parseJwt(currentToken);
      const timeUntilExpiry = decoded.exp * 1000 - Date.now();

      if (timeUntilExpiry < 5 * 60 * 1000) {
        if (verbose) {
          console.info('[Token refresh] ID token expiring soon, refreshing...');
        }
        await user.getIdToken(true);
        if (verbose) {
          console.info('[Token refresh] ID token refreshed successfully');
        }
      }
    } catch (err) {
      console.error('[Token refresh] Failed to refresh token:', err);
    }
  }, 60 * 1000);
}
